const en = {
  en: {
    buttons: {
      save: "Save",
      cancel: "Cancel",
      search: "Search",
      new: "New",
      langBtn: "AR",
      send: "Send",
      view: "View",
      review: "Review",
      approve: "Approve",
      upload: "Upload",
      edit: "Edit",
      submit: "Submit",
      remove: "Remove",
      sendRequest: "Send Request",
      submitProposal: "Submit",
      download: "Download",
      login: "Sign in",
      forgetPassword: "Forget Password",
      resetPassword: "Reset Password",
      reset: "Reset",
      addNew: "Add New",
    },
    shared: {
      done: "Saved Successfully",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
    },
    controls: {
      selectDocumentType: "Document Type",
      password: "Password",
      email: "Email Address",
      from: "From",
      to: "To",
      firstName: "First Name",
      lastName: "Last Name",
      userName: "User Name",
      uploadFile: "Upload File",
      jobTitleNameEn: "Job Title (En)",
      jobTitleNameAr: "Job Title (Ar)",
      industry: "Industry",
      currency: "Currency",
      salaryMin: "Min",
      salaryMax: "Max",
      sector: "Sector",
      country: "Country",
      nationality: "Nationality",
      yearsOfExperience: "Years Of Experience",
      basicSalary: "Average Salary",
      companyName: "Company Name",
      source: "Source",
      status: "Status",
      jobTitle: "Job Title",
      employeeType: "Employee Type",
      project: "Project",
      languages: "Language",
      neededData: "Needed Data",
      reportLine: "Report Line",
      createdBy: "Created By",
      approvalStatus: "Approval Status",
      projectName: "location Name",
      companyNameEn: "Company Name (En)",
      companyNameAr: "Company Name (Ar)",
      assignedTo: "Assigned To",
      toBeApprovedBy: "Approved By",
      template: "Template",
      roleNameEn: "Role Name (En)",
      roleNameAr: "Role Name (Ar)",
      companyWebsite: "Company Website",
      representativeName: "Representative Name",
      representativePosition: "Representative Position",
      location: "Location",
      partner: "Partner",
      numOfEmployees: "Number of Employees",
      timeLine: "Time Line",
      numOfPhases: "Number of Phases",
      proposalExpectedSubmissionDate: "Submission Date",
      organizationSegment: "Organization Segment",
      organizationSize: "Organization Size",
      proposalLanguage: "Proposal Language",
      documentURL: "Document URL",
      documentName: "Document Name",
      numberOfUniqueFiles: "Number of Unique Titles",
      invoiceValue: "Invoice Value",
      invoiceNumber: "Invoice Number",
      invoiceDate: "Invoice Date",
      ntpIssuedDate: " NTP Issued Date",
      biddingNumber: "Bidding Number",
      pipelines: "Pipelines",
      phaseDescription: "Phase Description",
      phaseName: "Phase Name",
      department: "Department",
      clientComplexity: "Client Complexity",
      clientFinancialAbilit: "Client Financial Ability ",
    },
    salaryGrades: {
      addNew: "Add New",
      manual: "Manual",
      aiSearching: "AI Searching",
      ai: "AI",
      cell: "Excel",
      actions: "Actions",
      addAgent: "Add Agent",
    },
    errors: {
      required: "This field is required",
      numberRequired: "This field must contain only numbers",
      wizardFileSizeErr: "Max size is 5MB",
      wizardFileTypeErr: "Excel files are only allowed",
      validEmail: "Invalid email",
      uploadFiles:
        "Unsupported file format. Please upload JPG, PNG, PDF, DOCX, PPT, or PPTX files.",
      allowedSize: "File size should not exceed 50MB",
    },

    uploads: {
      agentsTooltipRepeatEmails: "Emails cannot be repeated",
      agentsTooltipMandatory: "All columns are mandatory",
      agentsTooltipSalaryNameMaxChar: "salary name is maxed 50 characters each",
      agentsTooltipMaxMinDiff: "Max should be greater than min",
      agentsTooltipSalaryNameUnique: "salary grade name should be unique",
      agentsTooltipDownload: "Download the Excel sheet sample first",
      agentsTooltipRemoveColumn:
        "Don't remove or add columns to the excel sheet",
      agentsTooltipFirstLastNameMaxChar:
        "First name, Last name are maxed 50 characters each",
      uploadExcel: "Import from excel",
      downloadSample: "Download sample",
    },
    jobDescription: {
      jobDescriptionApproval: "Job Description Approval",
    },
  },
};

export default en;
